import React from "react";
import './contacts.css';

export default function Contacts({ }) {
    return (<React.Fragment>
        <h2>TIMPANOGOS TRIBAL GOVERNMENT</h2>
        <br />
        <div className="contact-info">
            <ul className="contacts">
                <li>Chief Executive.......... Mary Meyer</li>
                <li>Councilman................. Carl Christensen</li>
                <li>Councilman................. Perry Murdock</li>
                <li>Councilwoman................. Michele Groo</li>
                <li>Councilwoman........... Jensine Aguilar</li>
            </ul>
        </div>
        <h2>CONTACT INFORMATION</h2>
        <div className="contact-info">
            <div>
                <p className="pobox">Timpanogos Nation </p>
                <p className="pobox">Ft. Duchesne, Utah 84026</p>
                <p className="pobox">P.O. Box 327</p>
            </div>
        </div>
        <img src="img/beaded_eagle.jpg" alt="beaded eagle" />
    </React.Fragment>)
}